module.exports = __webpack_public_path__ + "static/media/30-4.31981657.mp3";